import * as React from "react";

export interface IGInputErrorMessageProps {
    label?: string;
}

export const GInputErrorMessage: React.FC<IGInputErrorMessageProps> = ({ label = null }: IGInputErrorMessageProps) => {
    if (!label) {
        return null;
    }
    return (
        <div className="g-input-error-message">{ label }</div>
    );
};
